/* GB Threads: navigate from the product size selector to the local Size Guide tab.
   Uses the existing theme tabs/accordion controls. No external navigation. */
(function(){
'use strict';
const tabId='tab-gb-size-guide';
function openGuide(button){
 const section=button.closest('.main-product-template');
 if(!section)return;
 const tabs=section.querySelector('.product__info-as-bottom-tabs');
 if(!tabs)return;
 const desktop=window.matchMedia('(min-width: 750px)').matches;
 const title=desktop?tabs.querySelector('.product__info-bottom .gb-size-guide-tablink'):tabs.querySelector('.gb-size-tab-mobile');
 if(!title)return;
 title.click();
 const panel=tabs.querySelector('.gb-size-guide-tabcontent');
 window.requestAnimationFrame(()=>{
   if(desktop && panel && !panel.classList.contains('tab-active-content')){
     tabs.querySelectorAll('.product__info-bottom .tablinks').forEach(el=>el.classList.remove('active-tab'));
     tabs.querySelectorAll('.dt-sc-tabs-content').forEach(el=>el.classList.remove('tab-active-content'));
     title.classList.add('active-tab');
     panel.classList.add('tab-active-content');
   }
   if(!desktop && !title.classList.contains('active')){
     tabs.querySelectorAll('.acc__title.active').forEach(el=>el.classList.remove('active'));
     title.classList.add('active');
   }
   title.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
 });
}
document.addEventListener('click',function(event){
 const b=event.target.closest('[data-gb-open-size-guide]');
 if(b){event.preventDefault();openGuide(b)}
});
document.addEventListener('keydown',function(event){
 const item=event.target.closest('.gb-size-guide-tablink[role="tab"]');
 if(!item || !['Enter',' '].includes(event.key))return;
 event.preventDefault();item.click();
});
})();
